// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.containerHomePage {
  display: flex;
}

.containerRequest {
  display: flex;
  width: calc(100% - 55px);
  padding: 30px 0px 0px 35px;
  flex-direction: column;
  margin-bottom: 30px;
}

.titleRequest {
  font-size: 18px;
}

.containerBalls {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.partNumberColluns {
  display: flex;
  padding-left: 20px;
  font-size: 14px;
}

.centerText {
  width: 100%;
  text-align: left;
  color: #979ea4;
}

.genericGrid {
  width: 100%;
  display: flex;
  padding: 0px 50px 100px 35px;
}

.MuiDataGrid-root .MuiDataGrid-footerContainer {
  border: none !important;
  height: 0px !important;
  background-color: #f9f9f9 !important;
}

.MuiDataGrid-root {
  border: none !important;
  height: 92% !important;
}

.MuiDataGrid-root .MuiDataGrid-filler {
  background-color: #f9f9f9 !important;
  border: none !important;
  height: 0px !important;
}

.buttonImg img {
  width: 22px;
}

.buttonInit img {
  width: 20px !important;
}

.buttonActions {
  margin-top: 0px;
}

.notificationImage {
  position: absolute;
  top: -8px;
  right: 37px;
  width: 20px;
  height: 20px;
  z-index: 999;
}

.descriptionText {
  white-space: normal; /* deixa quebrar linha se precisar */
  overflow: hidden;
  text-overflow: ellipsis;
}

.nullDescription {
  color: #999;
  font-style: italic;
}

.text-plus {
  text-decoration: underline;
  color: #007bc0;
  cursor: pointer;
  margin-left: 4px;
  font-size: 16px;
  font-family: "Bosch-sans", sans-serif;
  line-height: inherit;
  
  background: none;
  border: none;
  padding: 5px;
  margin-top: 15px;

  display: inline;
  white-space: nowrap;
}


.text-plus:hover {
  text-decoration: underline;
  background-color: #d1e4ff;
}

.MuiTooltip-tooltip {
  background-color: #fff !important;
  color: #000 !important;
  border: 1px solid #d9d9d9 !important;
  border-radius: 0px !important;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.25) !important;
  font-family: "Bosch Sans", sans-serif !important;
  font-size: 12px !important;
}


.dowloadTitles{
  margin-bottom: 20px;
}
.modal-body-download{
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  margin-bottom: 20px;
}

.exportBtn {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 8px;
}

.iconButton {
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 4px;
}

.iconButton:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.iconDownload {
  width: 20px;
  height: 20px;
}

`, "",{"version":3,"sources":["webpack://./src/componentes/fluxo-engenheiro/Requests/requests.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,0BAA0B;EAC1B,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mBAAmB,EAAE,oCAAoC;EACzD,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qCAAqC;EACrC,oBAAoB;;EAEpB,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,gBAAgB;;EAEhB,eAAe;EACf,mBAAmB;AACrB;;;AAGA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,sBAAsB;EACtB,oCAAoC;EACpC,6BAA6B;EAC7B,0DAA0D;EAC1D,gDAAgD;EAChD,0BAA0B;AAC5B;;;AAGA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":[".containerHomePage {\n  display: flex;\n}\n\n.containerRequest {\n  display: flex;\n  width: calc(100% - 55px);\n  padding: 30px 0px 0px 35px;\n  flex-direction: column;\n  margin-bottom: 30px;\n}\n\n.titleRequest {\n  font-size: 18px;\n}\n\n.containerBalls {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n}\n\n.partNumberColluns {\n  display: flex;\n  padding-left: 20px;\n  font-size: 14px;\n}\n\n.centerText {\n  width: 100%;\n  text-align: left;\n  color: #979ea4;\n}\n\n.genericGrid {\n  width: 100%;\n  display: flex;\n  padding: 0px 50px 100px 35px;\n}\n\n.MuiDataGrid-root .MuiDataGrid-footerContainer {\n  border: none !important;\n  height: 0px !important;\n  background-color: #f9f9f9 !important;\n}\n\n.MuiDataGrid-root {\n  border: none !important;\n  height: 92% !important;\n}\n\n.MuiDataGrid-root .MuiDataGrid-filler {\n  background-color: #f9f9f9 !important;\n  border: none !important;\n  height: 0px !important;\n}\n\n.buttonImg img {\n  width: 22px;\n}\n\n.buttonInit img {\n  width: 20px !important;\n}\n\n.buttonActions {\n  margin-top: 0px;\n}\n\n.notificationImage {\n  position: absolute;\n  top: -8px;\n  right: 37px;\n  width: 20px;\n  height: 20px;\n  z-index: 999;\n}\n\n.descriptionText {\n  white-space: normal; /* deixa quebrar linha se precisar */\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.nullDescription {\n  color: #999;\n  font-style: italic;\n}\n\n.text-plus {\n  text-decoration: underline;\n  color: #007bc0;\n  cursor: pointer;\n  margin-left: 4px;\n  font-size: 16px;\n  font-family: \"Bosch-sans\", sans-serif;\n  line-height: inherit;\n  \n  background: none;\n  border: none;\n  padding: 5px;\n  margin-top: 15px;\n\n  display: inline;\n  white-space: nowrap;\n}\n\n\n.text-plus:hover {\n  text-decoration: underline;\n  background-color: #d1e4ff;\n}\n\n.MuiTooltip-tooltip {\n  background-color: #fff !important;\n  color: #000 !important;\n  border: 1px solid #d9d9d9 !important;\n  border-radius: 0px !important;\n  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.25) !important;\n  font-family: \"Bosch Sans\", sans-serif !important;\n  font-size: 12px !important;\n}\n\n\n.dowloadTitles{\n  margin-bottom: 20px;\n}\n.modal-body-download{\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  width: 100%;\n  margin-bottom: 20px;\n}\n\n.exportBtn {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 8px;\n}\n\n.iconButton {\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  padding: 4px;\n}\n\n.iconButton:disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.iconDownload {\n  width: 20px;\n  height: 20px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
